var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { Actor } from '../../../../classes/actor/Actor';
import { deserialize } from '../../../../utils/serializr/core/deserialize';
import { OrderedTaskStepEval } from './modules/OrderedTaskStepEval';
import { OrderedTaskStepUI } from './modules/OrderedTaskStepUI';
import { OrderedTaskStepState } from './modules/OrderedTaskStepState';
import { OrderedTaskStepProgress } from './modules/OrderedTaskStepProgress';
export class OrderedTaskStep extends Actor {
    type = 'step';
    selectionEvents = [];
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get stepState() {
        return new OrderedTaskStepState(this);
    }
    get stepEval() {
        return new OrderedTaskStepEval(this);
    }
    get stepProgress() {
        return new OrderedTaskStepProgress(this);
    }
    get stepUI() {
        return new OrderedTaskStepUI(this);
    }
    get task() {
        return this.parent;
    }
    get question() {
        return this.task.question;
    }
    get itemIndex() {
        return this.task.steps.indexOf(this);
    }
    get itemNumber() {
        return this.itemIndex + 1;
    }
    get correctOptionIndex() {
        return this.task.correctOrders.nearestCorrectOrder[this.itemIndex];
    }
    get correctOption() {
        return this.task.options[this.correctOptionIndex];
    }
    static fromSerialized(ser = {}) {
        return deserialize(OrderedTaskStep, ser);
    }
    static get serializeInfo() {
        return {
            extends: Actor.serializeInfo,
            props: {},
        };
    }
    static get stripInfo() {
        return {
            extends: Actor.stripInfo,
            props: {},
        };
    }
}
__decorate([
    observable.shallow
], OrderedTaskStep.prototype, "selectionEvents", void 0);
__decorate([
    memoize
], OrderedTaskStep.prototype, "stepState", null);
__decorate([
    memoize
], OrderedTaskStep.prototype, "stepEval", null);
__decorate([
    memoize
], OrderedTaskStep.prototype, "stepProgress", null);
__decorate([
    memoize
], OrderedTaskStep.prototype, "stepUI", null);
__decorate([
    memoize
], OrderedTaskStep, "serializeInfo", null);
__decorate([
    memoize
], OrderedTaskStep, "stripInfo", null);
